import React from 'react';

import cs from 'classnames';

import Typography from '../Typography/Typography';

const Header = ({
  title,
  subtitle,
  onBadgeClick = null,
  children,
  className,
  titleClassName,
  childrenClassName
}) => (
  <div
    className={cs(
      'relative z-10 flex justify-between gap-2 border-0 !border-b !border-solid !border-neutral-100 bg-white !px-4 py-2',
      className
    )}>
    <div className={cs('flex items-center gap-1', !title && !subtitle && 'hidden')}>
      {title && (
        <Typography
          variant="p"
          size="medium"
          weight="medium"
          className={cs('w-max first-letter:uppercase', titleClassName)}>
          {title}
        </Typography>
      )}
      {subtitle && (
        <div
          className={cs(
            'flex items-center justify-center rounded-full bg-primary-50 !py-1 px-[10px]',
            !!onBadgeClick && 'cursor-pointer'
          )}
          onClick={onBadgeClick}>
          <span className="w-max text-base font-500 capitalize leading-6 text-primary-600">
            {subtitle}
          </span>
        </div>
      )}
    </div>
    <div className={cs('flex flex-1 justify-end gap-2', childrenClassName)}>{children}</div>
  </div>
);

export default Header;
